import { render, staticRenderFns } from "./2021-2-7.vue?vue&type=template&id=e24d3e04&scoped=true&"
import script from "./2021-2-7.vue?vue&type=script&lang=ts&"
export * from "./2021-2-7.vue?vue&type=script&lang=ts&"
import style0 from "./2021-2-7.vue?vue&type=style&index=0&id=e24d3e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24d3e04",
  null
  
)

export default component.exports